export default "__VITE_ASSET__vxW08x8d__"